import * as React from "react";
import { Popover, PopoverProps } from "@material-ui/core";
import { useState } from "react";
import { SalesforceEditAuthenticator } from "./Groopits/SalesforceEditAuthenticator";

interface Props extends PopoverProps {
  options: string[];
  selected: string[];
  multiple: boolean;
  name: string;
  isLinkedToSalesforce: boolean;
  onSelectionChange: (selected: string[]) => void;
}

export const FlagPopover = (props: Props) => {
  const {
    open,
    options,
    onClose,
    anchorEl,
    multiple,
    name,
    title,
    isLinkedToSalesforce,
    onSelectionChange,
  } = props;
  const [selected, setSelected] = useState(props.selected);

  const updateSelection = (option: string[]) => {
    onSelectionChange(option);
    setSelected(option);

    // close the selection immediately if it is a single
    // selection tag
    if (!multiple) {
      onClose?.({}, "escapeKeyDown");
    }
  };
  return (
    <Popover
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
    >
      <div className="max-w-sm">
        <div className="m-4 text-display-normal text-color-secondary flex gap-2 items-start">
          <div className="flex-grow">
            {isLinkedToSalesforce && <SalesforceEditAuthenticator />}
            <div>
              <img
                title="Tag"
                src="/Content/Images/ic_tag.png"
                className="groopit-component-icon-sm mx-2"
              />
              {title}
            </div>
          </div>
          <button
            title="Close"
            className="flex-shrink-0"
            onClick={(e) => onClose?.(e, "escapeKeyDown")}
          >
            <img title="Close" src="/Content/Images/x.png" className="w-4" />
          </button>
        </div>
        <div className="m-4">
          {options.map((option, i) => (
            <label
              key={i}
              className={`btn btn-tag text-break-words ${
                selected.includes(option) && "active"
              } ${!multiple && "singlechoice"}`}
            >
              <input
                className="hidden" // 'hidden' hides the checkbox
                type={multiple ? "checkbox" : "radio"}
                title={option}
                value={option}
                name={name}
                autoComplete="off"
                checked={selected.includes(option)}
                // special hack here to unselect the option when it is clicked
                onClick={() => {
                  if (!multiple && selected.includes(option)) {
                    updateSelection([]);
                  }
                }}
                onChange={(e) => {
                  if (e.target.checked) {
                    updateSelection(
                      multiple
                        ? [...selected, e.target.value]
                        : [e.target.value],
                    );
                  } else {
                    updateSelection(
                      multiple ? selected.filter((s) => s !== option) : [],
                    );
                  }
                }}
              />
              {option}
            </label>
          ))}
        </div>
      </div>
    </Popover>
  );
};
